import Vue from 'vue';
import App from './App.vue';
import Helper from './helper/Helper';
import './registerServiceWorker';
import router from './router';
import store from './store';

Vue.config.productionTip = false;
Object.defineProperty(Vue.prototype, '$helper', { value: Helper });

// Vue.prototype.bus = new Vue(); // bus for sending events from parent to child components

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
